export const drinkItems = [
    'Filtered Water', 'Coffee', 'Electrolyte powders',
    'Tap/Bottled Water', 'Decaf coffee', 'Kombucha / probiotic drinks',
    'Coconut water', 'Black Tea', 'Nondairy Milk',
    'Sparkling water', 'Herbal Tea', 'Full Fat Milk',
    'Juice', 'Energy drinks', 'Protein shakes',
    'Vegetable / Fruit Juice (fresh)', 'Gatorade', 'Pre-workout',
    'Smoothies', 'Alcohol', 'Other (please name)',
];
